import React, { FC, ReactElement, useEffect, useState } from "react";
import HomeIcon from "@mui/icons-material/Home";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import ButtonUI from "../../../../../components/button/buttons";
import TextIcon from "../../../../../components/TextIcon/TextIcon";
import { AiFillCarryOut } from "react-icons/ai";
import {
  DAY_LABELS,
  days,
  FREQUENCY_LABELS,
  weeks,
} from "../../../../../const/day.const";

interface CardComponentInterface {
  openModal?: () => void;
  data?: any;
}
const CardComponent: FC<CardComponentInterface> = ({ openModal, data }) => {
  const [selectWeek, setSelectWeek] = useState<string>();
  const [frequency, setFrequency] = useState<string>("");
  const [payDay, setPayDay] = useState<string>("");

  useEffect(() => {
    if (data?.response?.data?.config) {
      setFrequency(data?.response.data.config.frequency);
      setPayDay(data?.response.data.config.payday);
    }
  }, [data]);

  //console.log('data.response.data.config.frequency', data?.response?.data.config.frequency)
  const handleChangeFrequency = (event: SelectChangeEvent) => {
    setFrequency(event.target.value as string);
  };

  const handleChangePayDay = (event: SelectChangeEvent) => {
    setPayDay(event.target.value as string);
  };

  return (
    <Paper
      elevation={3}
      sx={{
        p: { xs: 2, sm: 3 },
        width: "100%",
        maxWidth: "none",
        minWidth: 0,
        boxSizing: "border-box",
      }}
    >
      <Box display="flex" alignItems="center" gap={1}>
        {" "}
        <TextIcon
          title="Dispersiones Automáticas"
          colorIcon="#9333EA"
          colorBackground="#FAF5FF"
          icon={(<AiFillCarryOut />) as ReactElement}
        />
      </Box>
      <Typography variant="body2" sx={{ mb: 2 }}>
        Configura una fecha recurrente para que tus ingresos se dispersen
        automáticamente a tu cuenta principal.
      </Typography>

      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel>Frecuencia</InputLabel>
        <Select
          disabled
          label="Frecuencia"
          onChange={handleChangeFrequency}
          value={frequency}
        >
          {weeks.map((week) => (
            <MenuItem
              key={week}
              value={week}
            >
              {FREQUENCY_LABELS[week]}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Día de pago */}
      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel>Día de Pago</InputLabel>
        <Select
          disabled
          label="Día de Pago"
          onChange={handleChangePayDay}
          value={payDay}
        >
          {days.map((day) => (
            <MenuItem key={day} value={day}>
              {DAY_LABELS[day]}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <ButtonUI
        color="primary"
        fullWidth
        variant="contained"
        title=" Actualizar Configuración"
        onClick={openModal}
      />
    </Paper>
  );
};

export default CardComponent;
